import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Columns } from '../../../dbWebUI'
import MediaCard from '../mediaCard/MediaCard'

import './MediaGrid.css'
import { BOOKSHELF_PLUS_IDS, DIGITAL_VIP_IDS } from '../../../subscriptionIds'
import checkMediaSubscription from '../../../utils/checkMediaSub'

/**
 * Component for displaying multiple `MediaCard`s in a grid.
 *
 * TODO Write tests for this
 * TODO Add story for this
 * @param {object} props - component props
 * @returns {function} Component
 */
function MediaGrid(props) {
  const { className, media, mediaType, ...rest } = props
  const classes = classNames('MediaGrid', className)
  // Subscription IDs
  const plusIds = BOOKSHELF_PLUS_IDS
  const vipIds = DIGITAL_VIP_IDS

  /**
   * Renders individual `MediaCard`s.
   *
   * @returns {function} Component
   */
  const renderMedia = () =>
    media.map((mediaItem, i) => {
      const accessor = mediaItem && mediaItem.audiobook ? 'audiobook' : 'ebook'
      const sku = mediaItem[accessor] && mediaItem[accessor].sku

      // Collection of variables to be used in the component
      const isPlus = checkMediaSubscription(mediaItem[mediaType], plusIds)
      const isVip = checkMediaSubscription(mediaItem[mediaType], vipIds)

      return (
        <Columns.Column
          key={`${mediaItem.mediaId}-${sku}-${i}`}
          is6Mobile
          is4Tablet
          is3Desktop
          is3Widescreen
          is2Fullhd
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <MediaCard media={mediaItem} mediaType={mediaType} isPlus={isPlus} isVip={isVip} />
        </Columns.Column>
      )
    })

  /** TODO render an empty state. */
  if (!media.length) {
    return false
  }

  return (
    <Columns className={classes} isMobile isMultiline {...rest}>
      {renderMedia()}
    </Columns>
  )
}

MediaGrid.defaultProps = {
  className: '',
  media: [],
  mediaType: 'ebook',
}

MediaGrid.propTypes = {
  /** Additional classes */
  className: PropTypes.string,
  /** Media objects to display as `MediaCard`s */
  media: PropTypes.arrayOf([]),
  /** Type of media to display, ebook or audiobook */
  mediaType: PropTypes.string,
}

export default MediaGrid
